import { render, staticRenderFns } from "./waitReturn.vue?vue&type=template&id=89bfe054"
import script from "./waitReturn.vue?vue&type=script&lang=js"
export * from "./waitReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports